(function () {
  function initShopAll(root) {
    initDrawer(root);
    initMobileView(root);
    initDesktopAutoSubmit(root);
    initDesktopSidebarScroll(root);
    initLoadMore(root);
  }

  function initDrawer(root) {
    var trigger = root.querySelector('[data-shop-all-drawer-trigger]');
    var drawer = root.querySelector('#ShopAllDrawer');
    if (!trigger || !drawer || drawer.dataset.shopAllDrawerBound === 'true') return;

    drawer.dataset.shopAllDrawerBound = 'true';

    var closers = drawer.querySelectorAll('[data-shop-all-drawer-close]');
    var panel = drawer.querySelector('.shop-all-drawer__panel');
    var lastFocusedElement = null;

    function getFocusableElements() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll(
          'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function openDrawer() {
      lastFocusedElement = document.activeElement;
      drawer.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('shop-all-drawer-open');

      var focusableElements = getFocusableElements();
      if (focusableElements.length) {
        focusableElements[0].focus();
      } else if (panel) {
        panel.setAttribute('tabindex', '-1');
        panel.focus();
      }
    }

    function closeDrawer() {
      drawer.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('shop-all-drawer-open');

      if (panel) {
        panel.removeAttribute('tabindex');
      }

      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      } else {
        trigger.focus();
      }
    }

    trigger.addEventListener('click', function () {
      if (drawer.hidden) {
        openDrawer();
      } else {
        closeDrawer();
      }
    });

    closers.forEach(function (closer) {
      closer.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && !drawer.hidden) {
        var focusableElements = getFocusableElements();
        if (!focusableElements.length) {
          event.preventDefault();
          return;
        }

        var firstElement = focusableElements[0];
        var lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }

      if (event.key === 'Escape' && !drawer.hidden) {
        closeDrawer();
      }
    });
  }

  function initMobileView(root) {
    var grid = root.querySelector('[data-shop-all-grid]');
    var buttons = root.querySelectorAll('[data-shop-all-view]');
    if (!grid || !buttons.length) return;

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var value = button.getAttribute('data-shop-all-view');
        grid.setAttribute('data-mobile-columns', value);

        buttons.forEach(function (item) {
          var isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      });
    });
  }

  function initDesktopAutoSubmit(root) {
    var form = root.querySelector('[data-shop-all-auto-submit]');
    if (!form || form.dataset.shopAllAutoSubmitBound === 'true') return;

    form.dataset.shopAllAutoSubmitBound = 'true';

    form.addEventListener('change', function () {
      form.submit();
    });
  }

  function initDesktopSidebarScroll(root) {
    var scrollArea = root.querySelector('.shop-all-page__sidebar .shop-all-filters');
    if (!scrollArea || scrollArea.dataset.shopAllWheelBound === 'true') return;

    scrollArea.dataset.shopAllWheelBound = 'true';

    scrollArea.addEventListener(
      'wheel',
      function (event) {
        var deltaY = event.deltaY;
        if (window.matchMedia('(max-width: 1080px)').matches) return;
        if (!deltaY) return;

        var maxScrollTop = scrollArea.scrollHeight - scrollArea.clientHeight;
        if (maxScrollTop <= 0) return;

        var nextScrollTop = Math.max(0, Math.min(maxScrollTop, scrollArea.scrollTop + deltaY));
        var willScrollInternally = nextScrollTop !== scrollArea.scrollTop;

        if (willScrollInternally) {
          event.preventDefault();
          scrollArea.scrollTop = nextScrollTop;
        }
      },
      { passive: false }
    );
  }

  function initLoadMore(root) {
    var pagination = root.querySelector('[data-shop-all-load-more]');
    var button = root.querySelector('[data-shop-all-load-more-button]');
    var grid = root.querySelector('[data-shop-all-grid]');
    if (!pagination || !button || !grid || button.dataset.shopAllBound === 'true') return;

    button.dataset.shopAllBound = 'true';

    button.addEventListener('click', function () {
      var nextUrl = pagination.getAttribute('data-next-url');
      if (!nextUrl || button.disabled) return;

      var label = button.querySelector('.shop-all-page__load-more-label');
      var defaultLabel = button.getAttribute('data-default-label') || 'Shop More';
      var loadingLabel = button.getAttribute('data-loading-label') || 'Brewing More';
      button.disabled = true;
      if (label) {
        label.textContent = loadingLabel;
      }

      fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load next page');
          return response.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-shop-all-grid]');
          var nextPagination = doc.querySelector('[data-shop-all-load-more]');

          if (!nextGrid) throw new Error('Missing next grid');

          Array.prototype.slice.call(nextGrid.children).forEach(function (item) {
            grid.appendChild(item);
          });

          if (nextPagination && nextPagination.getAttribute('data-next-url')) {
            pagination.setAttribute('data-next-url', nextPagination.getAttribute('data-next-url'));
            button.disabled = false;
            if (label) {
              label.textContent = defaultLabel;
            }
          } else {
            button.disabled = false;
            if (label) {
              label.textContent = defaultLabel;
            }
            pagination.removeAttribute('data-next-url');
            button.remove();
            pagination.hidden = true;
          }
        })
        .catch(function () {
          window.location.href = nextUrl;
        });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-shop-all]').forEach(initShopAll);
  });

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-shop-all]').forEach(initShopAll);
  });
})();
